import { Injectable } from '@angular/core';
import { BehaviorSubject, concat, interval, Observable } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { HSPAPermission } from 'src/app/shared/models/hspa-permission.enum';
import { APIClient } from '../api-client/contracts/api-client.service';
import { AuthService } from './auth.service';
import { IUser } from 'src/app/shared/models/IUser';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeService {

  private userSubject = new BehaviorSubject<IUser | null | any>(null);
  public isAuthorizeSubject = new BehaviorSubject<boolean>(true);

  constructor(private client: APIClient,
    private authService: AuthService)
    { }

  public isAuthenticated(): Observable<boolean> {
    return this.client.get<boolean>('auth/IsLoggedIn');
  }

  public getUser(): Observable<IUser | null | any> {
    return concat(
      this.userSubject.pipe(
        take(1),
        filter((u) => !!u),
      ),
      this.client.get('auth/getuser').pipe(
        filter((u) => !!u),
        tap((u) => this.userSubject.next(u)),
      ),
      this.userSubject.asObservable(),
    );
  }

  public signOut(): void {
    this.authService.revokeTokenAndLogout();
    this.clearSpecificLocalStorage();
  }

  public hasPermission(permission: HSPAPermission): Observable<boolean> {
    return this.client.get<boolean>(`auth/HasPermission?permission=${permission}`);
  }

  clearSpecificLocalStorage(): void {
    localStorage.removeItem('tenantId');
    localStorage.removeItem('facilityId');
    localStorage.removeItem('userRole');
  }
}
